import { RestSlice } from '../../../../../redux/rest.slice';
import { IppUnitTranslations } from '@rcp/types';
import { Resource, localizationService } from 'src/services';

export const ippUnitTranslationSlice = new RestSlice<IppUnitTranslations>(
	localizationService.getLocalizedString('ipp.unitTranslations.pageHeading'),
	Resource.IppUnitTranslations
);
export default ippUnitTranslationSlice.rests.reducer;
